// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610210706/js/" + chunkId + "." + {"44":"ef87b014","225":"0e4df1c5","481":"e7c3d0b5","486":"d827140c","770":"bdbadef3"}[chunkId] + ".0.43892304932894344.chunk.js";
};